import { useEffect } from "react";
import { useChallengeStore } from "@/store/challenges/challenges.store";

export const useSingleChallengeBasedOnGame = (
  client: string,
  state: "ongoing" | "upcoming" | "finished",
  gameType: string
) => {
  const key = `${client}-${state}-${gameType}`;
  const { challenges, fetchChallenge } = useChallengeStore();
  const challenge = challenges[key] || {
    loading: true,
    error: null,
    slug: null,
  };

  useEffect(() => {
    fetchChallenge(client, state, gameType);
  }, [client, state, gameType, fetchChallenge]);

  return {
    loading: challenge.loading,
    error: challenge.error,
    slug: challenge.slug,
  };
};
